import { AuthProviderFactory } from './AuthProviderFactory';

export class AuthProvider {
    constructor() {
        this.authProviderFactory = new AuthProviderFactory();
        this.authProvider = this.authProviderFactory.build(null,null);
    }

    initProvider = (authConfig) => {
        this.authProvider = this.authProviderFactory.build(authConfig);
    };

    login = (language) => {
        localStorage.removeItem("va_login_redirect");
        this.authProvider.login(language);
    } 

    signup = (language) => {
        this.authProvider.signup(language);
    }

    loginWithReturnUrl = (returnUrl, language) => {
        localStorage.setItem("va_login_redirect", returnUrl);
        this.authProvider.login(language);
    } 

    silentAuthentication = (callback) => {
        return this.authProvider.silentAuthentication(callback);
    };

    otcAuthentication = (code, userName) => {
        return this.authProvider.otcAuthentication(code, userName);
    };

    passUserName = (userName) => {
        return this.authProvider.passUserNameToCas(userName);
    };

    handleAuthentication = async (callback) => {
        return this.authProvider.handleAuthentication(callback);
    };

    logout = () => {
        return this.authProvider.logout();
    };

    getAccessToken = () => {
        return this.authProvider.getAccessToken();
    };

    getProfile = () => {
        return this.authProvider.getProfile();
    };

    getTokenTimeToLive = () => {
        return this.authProvider.getTokenTimeToLive();
    };

    isAuthenticated = () => {
        return this.authProvider.isAuthenticated();
    };

    redirect = (app, route) => {
        this.authProvider.redirect(app, route);
    }
}

const auth = new AuthProvider();
export default auth;

